import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import BeforeDatabasePreparedEvent from "@/modules/database/events/BeforeDatabasePreparedEvent";
import {Capacitor} from '@capacitor/core';
import {persistDataSource, sqliteConnection} from "@/modules/database/services/db";
import {initDataSource} from "@/modules/base/services/db";
import {Application} from "@/di";
import {BaseEntity} from "@/modules/base/entity";

@injectable()
export class DatabaseEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Application) private app: Application,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeDatabasePreparedEvent, callback: this.onBeforeDatabasePreparedEvent},
    ];
  }

  async onBeforeDatabasePreparedEvent(event: BeforeDatabasePreparedEvent): Promise<void> {
    const platform = Capacitor.getPlatform();

    let entities: Array<new () => BaseEntity> = [];
    this.app.modules.forEach(module => entities = [...entities, ...module.entities]);

    const dataSource = await initDataSource(entities);

    if (!dataSource.isInitialized) {
      await dataSource.initialize();
    }

    await dataSource.runMigrations();

    if (platform === 'web') {
      await sqliteConnection.saveToStore(dataSource.name);
    }

    // todo this is not working
    window.onunload = async () => {
      await persistDataSource(dataSource);
    };
  }
}
